package org.braunequip.web.components.models

import kotlinx.serialization.Serializable

/*
    Status Short Definitions
    0 - Marked as deleted
    1 - Pending (default)
    2 - Completed
    4 - Overdue

    NOTICE: WHENEVER PLAYING WITH `status` DOUBLE CHECK THEY'RE EQUAL WITH BACKEND
 */
@Serializable
data class MaintItemsDTO(
    var id: Int? = null,
    var assetId: Int? = null,
    var scheduleId: Int? = null,
    var scheduleName: String? = null,
    var dueMiles: Int? = null,
    var dueDate: String? = null, // String for LocalDate
    var status: Short? = null,
    var createdAt: String? = null, // String for LocalDateTime
    var completedDate: String? = null, // String for LocalDate
    var completedBy: String? = null // String for LocalDate
)

@Serializable
data class NewMaintItemRequest(
    val scheduleId: Int = -1,
    val assetIds: List<Int> = emptyList()
)

@Serializable
data class SkippedAssetDTO(
    val id: Int,
    val name: String
)

@Serializable
data class NewMaintItemResponse(
    val createdCount: Int,
    val skippedAssets: List<SkippedAssetDTO>
)

@Serializable
data class CompleteMaintItemRequest(
    val maintItemId: Int,
    val scheduleId: Int,
    val assetId: Int,
    val currentMiles: Int? = null,          // TODO: If user needs to input when it was done at.
    val completionDate: String? = null,      // TODO: If user got it done on a different date.
    val generateNext: Boolean = true
)
